<template>
  <footer class="wrap-footer">
    <div class="container-lg p-8 bg-white">
      <b-row class="m-0" no-gutters>
        <b-col class="">
          <b-img
            height="48"
            v-i18n-src="'@/assets/img/locales/{locale}/logo/logo.png'"
            class="mb-5"
          ></b-img>
          <ul
            class="text-gray700 list-unstyled text-14"
            style="user-select: text"
          >
            <li v-for="info in infos" :key="info.key">
              {{ info.title }}
            </li>
          </ul>
        </b-col>
        <b-col style="margin: 0 48px">
          <p class="title font-weight-bold m-0 text-18">{{ $t('服務') }}</p>
          <hr class="divider" />
          <ul class="list-unstyled">
            <li
              v-for="(service, index) in services"
              :key="service.key"
              :class="{'mb-5': index !== services.length - 1}"
            >
              <b-link
                class="text-14 text-gray700"
                :href="service.link"
                :target="service.target"
                >{{ service.title }}</b-link
              >
            </li>
          </ul>
        </b-col>
        <b-col class="">
          <p class="title font-weight-bold m-0 text-18">{{ $t('幫助') }}</p>
          <hr class="divider" />
          <ul class="list-unstyled">
            <li
              v-for="(help, index) in helps"
              :key="help.key"
              :class="{'mb-5': index !== helps.length - 1}"
            >
              <b-link
                class="text-14 text-gray700"
                :href="help.link || `#/${help.key}`"
                :target="help.link ? '_blank' : ''"
                >{{ help.title }}</b-link
              >
            </li>
          </ul>
        </b-col>
      </b-row>
    </div>
    <div class="copyright bg-primary text-center py-4 text-white">
      Copyright ©2023 IGQE, International Go Education Federation. All Rights
      Reserved.
    </div>
  </footer>
</template>

<script>
import {manifest} from '@/constant/env.js';

export default {
  name: 'Footer',
  data() {
    return {
      infos: [
        {
          key: 'agent',
          title: 'International Go Education Federation',
        },
        {
          key: 'email',
          title: 'service@igqe.org',
          link: 'service@igqe.org',
        },
      ],
      services: [
        {
          key: 'exam-list',
          title: this.$t('報名檢定'),
          link: '#/exam-list/1/',
        },
        {
          key: 'tournament-list',
          title: this.$t('報名比賽'),
          link: '#/tournament-list/1/',
        },
        {
          key: 'introduction',
          title: this.$t('關於IGQE'),
          link: '#/introduction/',
        },
        {
          key: 'official',
          title: 'IGEF Official Site',
          link: manifest.web,
          target: '_blank',
        },
      ],
      helps: [
        {
          key: 'faqs',
          title: this.$t('常見問題'),
        },
        {
          key: 'report',
          title: this.$t('問題回報'),
          link: manifest.report,
        },
        {
          key: 'terms-of-service',
          title: this.$t('服務條款'),
        },
        {
          key: 'exam-notice',
          title: this.$t('檢定須知'),
        },
      ],
    };
  },
};
</script>
<style lang="scss">
.wrap-footer {
  background: white;
  box-shadow: 0px -2px 4px 0px #00000013;
  .copyright {
    font-size: 13px;
  }
}
</style>
